import React from 'react';

export default function ShoppingCard() {
  return (
    <svg
      width='42'
      height='41'
      viewBox='0 0 42 41'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_di_1309_13809)'>
        <g clip-path='url(#clip0_1309_13809)'>
          <rect
            x='1'
            width='40'
            height='40'
            rx='12'
            fill='url(#paint0_linear_1309_13809)'
          />
          <g filter='url(#filter1_dd_1309_13809)'>
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M31.813 17.583C30.9022 18.8202 29.5516 19.6609 28.0394 19.9319C26.5272 20.2029 24.9687 19.8835 23.6849 19.0395C22.4012 18.1955 21.4902 16.8913 21.1395 15.3956C20.7888 13.8999 21.0252 12.3266 21.8 11H13.242L13.2 10.648C13.1138 9.9186 12.7631 9.24615 12.2142 8.7581C11.6653 8.27005 10.9565 8.00031 10.222 8H9V10H10.222C10.4669 10 10.7033 10.09 10.8864 10.2527C11.0694 10.4155 11.1863 10.6397 11.215 10.883L12.8 24.351C12.886 25.0806 13.2366 25.7533 13.7855 26.2415C14.3344 26.7298 15.0434 26.9997 15.778 27H29V25H15.778C15.5329 24.9999 15.2964 24.9099 15.1133 24.7469C14.9303 24.5839 14.8134 24.3594 14.785 24.116L14.654 23H30.836L31.813 17.583ZM18 30C18 31.1046 17.1046 32 16 32C14.8954 32 14 31.1046 14 30C14 28.8954 14.8954 28 16 28C17.1046 28 18 28.8954 18 30ZM28 30C28 31.1046 27.1046 32 26 32C24.8954 32 24 31.1046 24 30C24 28.8954 24.8954 28 26 28C27.1046 28 28 28.8954 28 30ZM26.078 17.542H26.111C26.3591 17.5429 26.6048 17.4944 26.834 17.3995C27.0632 17.3045 27.2712 17.165 27.446 16.989L31.714 12.714L30.3 11.3L26.112 15.5L23.868 13.16L22.427 14.542L24.733 16.942C24.905 17.1278 25.1128 17.2767 25.344 17.3799C25.5752 17.483 25.8249 17.5382 26.078 17.542Z'
              fill='url(#paint1_linear_1309_13809)'
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id='filter0_di_1309_13809'
          x='0.5'
          y='0'
          width='41'
          height='41'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='0.5' />
          <feGaussianBlur stdDeviation='0.25' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_1309_13809'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_1309_13809'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='0.5' />
          <feGaussianBlur stdDeviation='0.25' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect2_innerShadow_1309_13809'
          />
        </filter>
        <filter
          id='filter1_dd_1309_13809'
          x='-21'
          y='-18.1015'
          width='84'
          height='84'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='10' />
          <feGaussianBlur stdDeviation='10' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_1309_13809'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='3.89851' />
          <feGaussianBlur stdDeviation='15' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_1309_13809'
            result='effect2_dropShadow_1309_13809'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_1309_13809'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_1309_13809'
          x1='21'
          y1='0'
          x2='21'
          y2='40'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#29282C' />
          <stop offset='1' stop-color='#100F11' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_1309_13809'
          x1='8.82374'
          y1='3.06879'
          x2='26.5513'
          y2='27.7679'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
        <clipPath id='clip0_1309_13809'>
          <rect x='1' width='40' height='40' rx='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
